import { BlockTypes } from './Blocks/constants';

export const blocksWithoutContent = [
  BlockTypes.Experts,
  BlockTypes.HorizontalRule,
  BlockTypes.RecommendedArticles,
  BlockTypes.SubscribeMatrix,
];
